exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination[data-v-77fc5142]{margin:-.25rem;display:flex;flex-wrap:wrap}button[data-v-77fc5142]{background:none;border:0;padding:.25rem .5rem;margin:.25rem;background-color:#f2f2f2;color:#262626;line-height:1.1;font-size:14px;min-width:2em;border-radius:3px;transition:.2s ease-out}button.active[data-v-77fc5142]{background-color:#262626;color:#f2f2f2}button[disabled][data-v-77fc5142]{opacity:.5}", ""]);

// exports
